export enum PhoneType {
  MOBILE = 100,
  LANDLINE = 200,
  CUSTOM = 900,
}
